import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-business-wise-product-discount-trace-log',
  templateUrl: './business-wise-product-discount-trace-log.component.html',
  styleUrls: ['./business-wise-product-discount-trace-log.component.scss']
})
export class BusinessWiseProductDiscountTraceLogComponent implements OnInit {
  dataSource: Object;

  constructor(private global: GlobalService, private http: HttpService) {
    this.global.set_master_page_title = 'Business Wise Discount Trace';
    this.http.getBusinessWiseProductDiscountTraceLog().subscribe((data)=> {
      console.log(data);
      this.dataSource = data
    }, (error) => {
      console.error(error);
    });
   }

  ngOnInit() {
  }

}
